import React, {FC} from "react"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Modal from "@irati/ui/src/GenericModal"
import styled, {keyframes} from "styled-components"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import SuccessCheck from "@irati/ui/images/success-check.svg"
import Button from "@irati/ui/src/Button"

interface BenefitModalProps {
  isModalOpen: boolean
  isLoadingSecondState: boolean
  closeModal: () => void
  onClick: (type: string) => void
}

const spinAnimation = keyframes`
    0% {
        height: 120px;
        width: 120px;
        transform: rotate(0deg)
    }
    100% {
        height: 120px;
        width: 120px;
        transform: rotate(360deg);
    }
`
const Spinner = styled(Icon)`
  animation-name: ${spinAnimation};
  animation-timing-function: linear;
  animation-duration: 2s;
  animation-iteration-count: infinite;
`

const BenefitModal: FC<BenefitModalProps> = ({isModalOpen, isLoadingSecondState, closeModal, onClick}) => {
  return (
    <Modal small={true} show={isModalOpen} hideActions critical={isLoadingSecondState} onHide={closeModal}>
      {isLoadingSecondState ? (
        <Flex direction="column" alignItems="center">
          <Flex justifyContent="center" marginBottom={2}>
            <Spinner icon={IconTypes.spinner} />
          </Flex>
          <Body>Opening in a new tab…</Body>
        </Flex>
      ) : (
        <Flex gap={2} direction="column" alignItems="center">
          <img src={SuccessCheck} alt="" />
          <Body textAlign="center">The benefit page has been opened in a new browser tab</Body>
          <Button tertiary onClick={() => onClick("open_again")}>
            <Flex>
              Open again <Icon icon={IconTypes.upRightArrow} marginLeft={2} size={16} />
            </Flex>
          </Button>
        </Flex>
      )}
    </Modal>
  )
}

export default BenefitModal
